import {RiCheckboxCircleFill} from "@remixicon/react";
import {DynamicHtmlElement} from "@/components/ui/DynamicHtmlElement";
import {HTMLAttributes} from "react";

export const ProductDescriptors = ({
  descriptors,
  ...props
} : {
  descriptors?: string[];
} & HTMLAttributes<HTMLDivElement>) => {
  const additionalStyles = props.className || '';

  return descriptors && descriptors.length > 0 && (
    <ul className={`text-sm mt-2 space-y-2 xl:space-y-0 xl:gap-2 list-image-none flex-1 ${additionalStyles}`}>
      {descriptors.map((descriptor, index) => (
        <li key={index} className="flex gap-2">
          <div className="w-[24px] min-w-[24px] text-secondary">
            <RiCheckboxCircleFill />
          </div>
          <DynamicHtmlElement html={descriptor} className="leading-[22px]" />
        </li>
      ))}
    </ul>
  )
}
